import { getTodayFormatted, getThirtyDaysAgoFormatted } from '../utils/getFormattedDate';
import noAuthHttp from 'conversations-http/clients/noAuthApiClient';
import PortalIdParser from 'PortalIdParser';
const portalId = PortalIdParser.get();
export function fetchMostViewedArticles(knowledgeBaseId) {
  return noAuthHttp.post(`knowledge-content/v2/embedded-knowledge-base/most-viewed-articles?portalId=${portalId}`, {
    data: {
      startDate: getThirtyDaysAgoFormatted(),
      endDate: getTodayFormatted(),
      knowledgeBaseId,
      limit: 5
    }
  });
}
export function fetchArticleCategories(knowledgeBaseId) {
  return noAuthHttp.get(`/knowledge-content/v2/embedded-knowledge-base/categories-with-count/${knowledgeBaseId}?portalId=${portalId}`);
}
export function fetchCategoryArticles(knowledgeBaseId, categoryId) {
  return noAuthHttp.get(`knowledge-content/v2/embedded-knowledge-base/articles-in-category/${knowledgeBaseId}/category/${categoryId}?portalId=${portalId}`);
}